import type { Card } from '../types';
import raw from './cards.json';

export const cards: Card[] = raw as Card[];
export const cardById = new Map<number, Card>(cards.map((c) => [c.id, c]));

export function shuffledCards(): Card[] {
  const a = [...cards];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j] as Card, a[i] as Card];
  }
  return a;
}
